<template>
  <div>
    <v-row>
      <v-col>
        <span class="text-tcdc-green sub-header1 bold text-uppercase">
         {{branchName}}
        </span>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <template v-for="(item, index) of headers">
                  <th
                    :key="index.toString()"
                    class="text-left table-tcdc-header"
                  >{{ item[`text_${lang}`] }}</th>
                </template>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in membershipRate" :key="i">
                <td v-html="item[`name_${lang}`]"
                  class="table-tcdc-vertical-align-top  py-2 pl-0 ml-0 mr-12 table-content-tcdc-color vhtml"
                ></td>
                <td
                  class="table-tcdc-vertical-align-top  py-2 mx-12 table-content-tcdc-color color-16"
                  style="font-family: Sarabun; font-size: 16px;"
                >{{ item[`dayPass_${lang}`] ? item[`dayPass_${lang}`]:'' }}</td>
                <td
                  class="table-tcdc-vertical-align-top  py-2 ml-12 mr-0 table-content-tcdc-color vhtml"
                  v-html="item[`annual_${lang}`]"
                ></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <template v-for="(item, index) in members">
      <v-row :key="index" style="margin-bottom: 0 !important;">
        <v-col class="my-12" style="margin-bottom: 0 !important;">
          <div :key="item.title_id" class="vhtml" v-html="item[`title_${lang}`]"></div>
          <div :key="item.description_id" class="vhtml" v-html="item[`content_${lang}`]"></div>
        </v-col>
      </v-row>
    </template>
<!--    <v-row>-->
<!--      <v-col class="my-12">-->
<!--        <p class="table-tcdc-header bold mb-3">Membership rate at other branches</p>-->
<!--        <template v-for="(item, index) of tcdcBranches">-->
<!--          <div :key="index.toString()" @click="memberRateHandler(item.branch_id)">-->
<!--            <span class="text-uppercase text-tcdc-green bold cursor-pointer">-->
<!--              {{item.branch_name}}-->
<!--            </span>-->
<!--          </div>-->
<!--        </template>-->
<!--      </v-col>-->
<!--    </v-row>-->
  </div>
</template>

<script>
  import {mapState} from "vuex";

  export default {
    computed:{
      ...mapState({
        tcdcBranches : state=>{
          return state.Branch.branches;
        },
        branchName : state=>{
          return state.Branch.branch_name;
        },
        lang : state=>{
          return state.Branch.lang;
        },
        membershipRate: state => {
          return [
            ...state.ServiceMenu.membership_rate.map(rate=>({
              name_th : rate.detail_th,
              name_en : rate.detail_en,
              dayPass_th : rate.one_day_pass_th,
              dayPass_en : rate.one_day_pass_en,
              annual_th : rate.annual_fee_th,
              annual_en : rate.annual_fee_en
            }))
          ]
        },
        members: state => {
          return [
            ...state.ServiceMenu.member_tcdc.filter(val => val.member_topic_type_id === 2).map(member => ({
              title_id: member.id,
              description_id : parseInt(member.id) + 20,
              title_th: `<h class="bold sub-header1 text-tcdc-green">` + member.title_th + `</h> <br/><br/>`,
              title_en: `<h class="bold sub-header1 text-tcdc-green">` + member.title_en + `</h> <br/><br/>`,
              content_th: `<span>` + member.detail_th + `</span>`,
              content_en: `<span>` + member.detail_en + `</span>`,
            }))
          ]
        }
      }),
    },
  methods: {
    memberRateHandler(branch_id) {
      this.getBranchNameById(branch_id);
      this.getMembershipRateByBranch(branch_id);
    },
    getMembershipRateByBranch(branch_id){
      this.branch_id = branch_id;
      this.$store.dispatch("ServiceMenu/getMembershipRateByBranch",{
        id : this.branch_id,
        lang : this.lang
      })
    },
    getBranchNameById(id){
      this.$store.dispatch("Branch/getBranchById",id);
    }
  },
  data: () => ({
    branch_id : 1,
    headers: [
      {
        text_th: "สมาชิก",
        text_en: "Membership",
        align: "start",
        value: "name"
      },
      { text_th: "บัตรรายวัน", text_en: "1 day pass", value: "dayPass", width: "100px" },
      { text_th: "ค่าธรรมเนียมรายปี", text_en: "Annual fee", value: "annual", width: "100px" }
    ],
    bodys: []
  })
};
</script>

<style lang="scss" scoped>
th,
td {
  min-width: 160px;
}
.table-tcdc-header:first-child {
  padding-left: 0px;
}
.table-tcdc-header {
  font-family: Poppins,Kanit;
  font-size: 16px !important;
  font-weight: 400;
  color: $tcdcGrey1 !important;
}

.table-content-tcdc-color {
  color: $tcdc16;
  font-family: Sarabun;
  font-size: 16px !important;
}
.table-tcdc-vertical-align-top {
  vertical-align: top;
}
</style>
